import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LazyLoad from 'vanilla-lazyload';

const isServer = typeof window === 'undefined';

// Only initialize lazyload one time for the entire application
// @ts-expect-error ts-migrate(2339) FIXME: Property 'lazyLoadInstance' does not exist on type... Remove this comment to see the full error message
if (!isServer && !document.lazyLoadInstance) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'lazyLoadInstance' does not exist on type... Remove this comment to see the full error message
  document.lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy', // CSS selector of the elements to load lazily
    load_delay: 1, // Time (in ms) each img needs to stay inside the viewport before its loading begins
  });
}

export class LazyIframe extends React.Component {
  // Update lazyLoad after first rendering of every image
  componentDidMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'lazyLoadInstance' does not exist on type... Remove this comment to see the full error message
    document.lazyLoadInstance.update();
  }

  // Update lazyLoad after rerendering of every image
  componentDidUpdate() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'lazyLoadInstance' does not exist on type... Remove this comment to see the full error message
    document.lazyLoadInstance.update();
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'attributes' does not exist on type 'Read... Remove this comment to see the full error message
    const { attributes, classnames, src } = this.props;
    const classes = classNames({
      'lazy': true,
      [classnames]: !!classnames,
    });

    return <iframe className={classes} data-src={src}
      {...attributes} />;
  }
}

// @ts-expect-error ts-migrate(2339) FIXME: Property 'propTypes' does not exist on type 'typeo... Remove this comment to see the full error message
LazyIframe.propTypes = {
  attributes: PropTypes.object,
  classnames: PropTypes.string,
  src: PropTypes.string,
};

// @ts-expect-error ts-migrate(2339) FIXME: Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
LazyIframe.defaultProps = {
  attributes: {},
  classnames: '',
  src: '',
};

export default LazyIframe;
